export default "__VITE_ASSET__fa5e2fc5__"